import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * The severity chip, in one place.
 *
 * This map was copied verbatim into five files before the inbox needed a sixth. The
 * spec called that out rather than letting the count grow: five hand-kept copies is
 * how one of them quietly stops matching, and severity colour is the thing people
 * read before they read the words.
 *
 * `AuditCatalog` deliberately still has its own — it has already diverged (critical
 * and high share a colour there) and re-colouring an admin page is a visual decision,
 * not a refactor.
 */

const SEVERITY_STYLE: Record<string, string> = {
  critical: 'bg-sev-1/15 text-sev-1',
  high: 'bg-sev-2/15 text-sev-2',
  medium: 'bg-sev-3/20 text-foreground',
  low: 'bg-sev-4/15 text-sev-4',
  info: 'bg-sev-5/15 text-sev-5',
};

function severityStyle(severity: string): string {
  // Grey for anything outside the canonical five, which is the honest answer for a
  // value this build does not know — and for the inbox rows written before severity
  // was carried at all.
  return SEVERITY_STYLE[severity] ?? 'bg-muted text-muted-foreground';
}

export function SeverityBadge({ severity, className }: { severity: string; className?: string }) {
  return (
    <Badge className={cn('border-0 font-normal capitalize', severityStyle(severity), className)}>
      {severity}
    </Badge>
  );
}
